import React, { Component } from "react";
import { List, Segment } from "semantic-ui-react";

import EntityItem from "./Items/EntityItem";
import Pagination from "../../utils/Pagination";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between"
  },
  font: {
    fontSize: "16px",
    fontWeight: "bold"
  }
};

const options = [
  { key: "1", text: "10 por página", value: 10 },
  { key: "2", text: "20 por página", value: 20 },
  { key: "3", text: "50 por página", value: 50 },
  { key: "4", text: "100 por página", value: 100 }
];

export class EntitiesList extends Component {
  state = { paginatedItems: [], itemsPerPage: 10 };

  onChangePage = e => {
    this.setState({
      paginatedItems: e
    });
  };

  render() {
    const { entities } = this.props;
    const { paginatedItems, itemsPerPage } = this.state;
    let listItems = [];
    listItems = paginatedItems.map((entity, index) => {
      return (
        <EntityItem
          showEditEntityForm={this.props.showEditEntityForm}
          selectedEntity={this.props.selectedEntity}
          clearEntityInfo={this.props.clearEntityInfo}
          deleteEntity={this.props.deleteEntity}
          entity={entity}
          onChangeEntityCheckbox={this.props.onChangeEntityCheckbox}
          key={index}
        />
      );
    });
    return (
      <Segment className="listAlign">
        <List verticalAlign="middle" divided size="large">
          {entities.length > 0 ? (
            <List.Item className="listItemPadding">
              <List.Content verticalAlign="middle">
                <div style={styles.listItem}>
                  <label style={styles.font}>Nombre</label>
                  <div>
                    <label style={styles.font} className="labelAlign">
                      Habilitar
                    </label>
                    <label style={styles.font} className="labelAlign">
                      Borrar
                    </label>
                  </div>
                </div>
              </List.Content>
            </List.Item>
          ) : null}
          {listItems}
        </List>
        <Pagination
          items={entities}
          itemsPerPage={itemsPerPage}
          onChangePage={this.onChangePage}
          options={options}
        />
      </Segment>
    );
  }
}

export default EntitiesList;
